import { EyeOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { PROPERTY_TAB_KEYS } from '../../../common/propertyDetailTypes'
import { propertyDetailPath } from '../../utils/paths'
import { useSetPropertyDrawer } from '../../utils/useSetPropertyDrawer'

interface PropertyDetailLinkProps {
  text: React.ReactNode
  propertyId?: string
  propertyType: PROPERTY_TYPES
  isActive?: boolean
  target?: React.HTMLAttributeAnchorTarget
  drawerTarget?: boolean
  tab?: PROPERTY_TAB_KEYS
}

const label = {
  [PROPERTY_TYPES.AREA]: 'parcely',
  [PROPERTY_TYPES.BUILDING]: 'budovy',
  [PROPERTY_TYPES.UNIT]: 'jednotky',
}

export const PropertyDetailLink: React.FC<PropertyDetailLinkProps> = props => {
  const setDrawer = useSetPropertyDrawer()

  if (props.isActive) {
    return (
      <Tooltip
        className="text-gray-400"
        title={`Detail této ${label[props.propertyType]} si právě prohlížíte`}
      >
        <EyeOutlined /> {props.text}
      </Tooltip>
    )
  }

  if (!props.propertyId) {
    return (
      <span title="Detail není k dispozici" className="text-gray-400">
        {props.text}
      </span>
    )
  }

  if (props.drawerTarget) {
    return (
      <a
        href="#"
        onClick={e => {
          e.preventDefault()
          props.propertyId && setDrawer(props.propertyId, props.propertyType)
        }}
        title={`Zobrazit detail ${
          label[props.propertyType]
        } v postranním panelu`}
      >
        {props.text}
      </a>
    )
  }

  return (
    <Link
      title={`Zobrazit detail ${label[props.propertyType]} ${
        !props.target ? 'v novém okně' : ''
      }`}
      to={propertyDetailPath(props.propertyType, props.propertyId, props?.tab)}
      target={props.target || '_blank'}
    >
      {props.text}
    </Link>
  )
}
